import React, { useState, useEffect } from "react";
import styles from "./NewSingleTransport.module.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import TransportOverviewContent from "../../TransportCustomTabHeader/TransportOverviewContent";
import TransportItineraryContent from "../../TransportCustomTabHeader/TransportItineraryContent";
import TransportInclusionExclusionContent from "../../TransportCustomTabHeader/TransportInclusionExclusionContent";
import TransportPointRemember from "../../TransportCustomTabHeader/TransportPointRemember";
import TransportCancellation from "../../TransportCustomTabHeader/TransportCancellation";
import TransportGallery from "../../TransportCustomTabHeader/TransportGallery";
import {
  calculateLOS,
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../../utils/utils";
import moment from "moment";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import PageMetaData from "../../PageMetaData/PageMetaData";
import OgMetaTitles from "../../PageMetaData/OgMetaTitles";
import Skeleton from "react-loading-skeleton";
import PackageDetails from "../../ButtonToDownload/PackageDetails";
import NewShare from "../NewShareMailPrint/NewShare";
import NewPrint from "../NewShareMailPrint/NewPrint/NewPrint";
import {
  CrossWithBorder,
  SvgAccordion,
  SvgClock,
  SvgLocation,
} from "../../../utils/svgIcons";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import NewSendEnquiryPopup from "../../NewSendEnquiryPopup/NewSendEnquiryPopup";
import imgNotFound from "../../../assets/images/single-image.png";
import AgentSideBar from "../../../Pages/Agent/AgentSideBar/AgentSideBar";
import AgentHeader from "../../../Pages/Agent/AgentHeader/AgentHeader";

function NewSingleTransportPage() {
  const [date, setDate] = useState({
    setDay: "",
    setMonth: "",
    setYear: "",
  });
  const { transportHandle } = useParams();
  const [isSliderVisible, setIsSliderVisible] = useState(false);
  const [showRatePopup, setshowRatePopup] = useState(false);
  const [loader, setLoader] = useState(true);
  const [selectedAddOns, setSelectedAddOns] = useState([]);

  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState("sedan");
  const [ACtype, setACtype] = useState("withoutAC");
  const [openGetQuotePopup, setOpenGetQuotePopup] = useState(false);

  const handleSelectVehicleChange = (e) => {
    setSelectedVehicle(e.target.value);
  };

  const location = useLocation();

  const navigate = useNavigate();

  const [singlePackage, setSinglePackage] = useState({});

  const [selectedCategory, setSelectedCategory] = useState("");
  const [ratesOfPackages, setRatesOfPackages] = useState(null);
  const [guest, setGuest] = useState(1);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [singleTransportData, setSingleTransportData] = useState({});
  const [activePayment, setActivePayment] = useState("priceSummary");
  const [paymentDetails, setPaymentDetails] = useState(true);
  const [mobilePriceBreakup, setMobilePriceBreakup] = useState(false);
  const [priceBreakupPopup, setPriceBreakupPopup] = useState(false);
  const [allPackageHotels, setAllPackageHotels] = useState([]);
  const [packageRates, setPackageRates] = useState([]);
  const [markupData, setMarkupData] = useState([]);
  const [promotions, setPromotions] = useState([]);
  const [openOuterAccordion, setOpenOuterAccordion] = useState([
    "detailed_itinerary",
  ]);
  const [selectedDiscount, setSelectedDiscount] = useState([]);
  const [selectedAutomaticDiscount, setSelectedAutomaticDiscount] = useState(
    []
  );

  const handleDetailedFilter = (value) => {
    setDetailedFilter(value);
  };

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const detailedItinerary = [
    { label: "Overview", value: "overview" },
    // {
    //   label: singlePackage.totalDays + " " + "Days Itinerary",
    //   value: "itinerary",
    // },
    // { label: "Accommodation", value: "accommodation" },
    { label: "Gallery", value: "gallery" },
  ];

  const [filter, setFilter] = useState("detailed_itinerary");
  const [detailedFilter, setDetailedFilter] = useState("overview");
  const [openIndex, setOpenIndex] = useState(0);

  const { includingDestinations } = location?.state || {};

  const userType = localStorage.getItem("userType");
  const userDetails = JSON?.parse(localStorage?.getItem("userDetails"));
  const userToken = localStorage.getItem("token");
  const [commission, setCommission] = useState({});
  const [packageId, setPackageId] = useState(null);
  const [allDestinations, setAllDestinations] = useState([]);
  // markup fetch api
  const fetchMarkup = async () => {
    const myHeaders = new Headers();
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/markups`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          const findObject = result?.data?.find(
            (mark) => mark?.markupCustomer === "both"
          );
          if (findObject) {
            setMarkupData(findObject);
          } else {
            setMarkupData(null);
          }
        } else {
          setMarkupData("No data found");
        }
      })
      .catch((error) => console.error(error));
  };

  useEffect(() => {
    fetchMarkup();
  }, []);

  const handleSelectedAddOns = (addon) => {
    setSelectedAddOns((prevSelected) => {
      const isSelected = prevSelected.some(
        (selected) => selected.id === addon.id
      );
      if (isSelected) {
        return prevSelected.filter((selected) => selected.id !== addon.id);
      } else {
        return [...prevSelected, addon];
      }
    });
  };

  useEffect(() => {
    const updateHideToggle = () => {
      if (window.innerWidth <= 768) {
        setMobilePriceBreakup(true);
      } else {
        setMobilePriceBreakup(false);
      }
    };

    updateHideToggle(); // Set the initial state based on screen size
    window.addEventListener("resize", updateHideToggle);

    return () => window.removeEventListener("resize", updateHideToggle);
  }, []);

  const togglePaymentDetails = () => {
    setPaymentDetails(!paymentDetails);
  };

  const handleButtonClick = () => {
    setActivePayment((prev) =>
      prev === "priceSummary" ? "priceDetails" : "priceSummary"
    );
  };

  const [formData, setFormData] = useState({
    company_name: "",
    name: "",
    phone: "",
    email: "",
    querry_detail: "",
    country: "",
    state: "",
    city: "",
    address: "",
  });

  const [activeTab, setActiveTab] = useState("package-information");

  const renderContent = () => {
    switch (activeTab) {
      case "package-information":
        return (
          <TransportOverviewContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-itinerary":
        return (
          <TransportItineraryContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      // case "package-hotels":
      //     return (
      //         <AccommodationContent
      //             loader={loader}
      //             singleTransportData={singleTransportData}
      //             setSelectedCategory={setSelectedCategory}
      //             selectedCategory={selectedCategory}
      //             setSelectedMealPlan={setSelectedMealPlan}
      //             selectedMealPlan={selectedMealPlan}
      //             allPackageHotels={allPackageHotels}
      //             packageRates={packageRates}
      //             ratesOfPackages={ratesOfPackages}
      //         />
      //     );
      case "package-destinations":
        return (
          <TransportInclusionExclusionContent
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-cancellation":
        return (
          <TransportCancellation
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-remember":
        return (
          <TransportPointRemember
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      case "package-gallery":
        return (
          <TransportGallery
            singleTransportData={singleTransportData}
            loader={loader}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (packageRates.length > 0) {
      setSelectedMealPlan(packageRates[0]?.mealPlan);
    }
  }, [packageRates.length]);

  const [bookingData, setBookingData] = useState({});

  const commissionAmount = commission?.commissionAmount;
  const commissionType = commission?.commissionType;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }
    const data = {
      location: params.get("location"),
      room: params.get("room"),
      guest: params.get("guest"),
      children: params.get("children"),
      departureDay: params.get("checkinDay"),
      departureMonth: params.get("checkinMonth"),
      departureYear: params.get("checkinYear"),
      radio: params.get("radio"),
      childAge: childAges,
      date: params.get("date"),
      day: params.get("day"),
      month: params.get("month"),
      year: params.get("year"),
      packageId: params.get("packageId"),
      transportHandle: transportHandle,
    };

    setDate({
      setDay: data.day,
      setMonth: data.month,
      setYear: data.year,
    });

    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/transport-holidays/fetch/single/${transportHandle}`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setLoader(false);
        setSingleTransportData(data?.data);
        setSinglePackage(data?.data);
        setPackageId(data?.data?.packageId);
        // setSelectedCategory(
        //   data?.data?.packageHotels[0]?.accommodationCategory
        // );
        // if (data?.data?.packageItinerary[0]?.accommodation.length === 0) {
        //   showErrorToast("Accommodations are not added in this package.")
        //   return
        // }
        setSelectedCategory(
          data?.data?.hotelCategory[0]
          // data?.data?.packageItinerary[0]?.accommodation[0]?.hotelcategory
        );

        const allAccommodations = data?.data?.packageItinerary.flatMap(
          (item) => item.accommodation
        );

        if (allAccommodations) {
          const uniqueAccommodations = Array.from(
            new Map(
              allAccommodations?.map((hotel) => [hotel?.accommodationId, hotel])
            ).values()
          );
          setAllPackageHotels(uniqueAccommodations);
        }

        setPackageRates(data?.data?.packageRates);
        scrollToTop();
      })
      .catch((error) =>
        console.error(
          "There has been a problem with your fetch operation:",
          error
        )
      );

    const checkInDate = `${data.year}-${String(data.month).padStart(
      2,
      "0"
    )}-${String(data.date).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    setGuest(data.guest);

    if (data.date && data.month && data.year) {
      setStartDate(checkInDate);
    } else {
      setStartDate(currentDateSingle);
    }
    // setStartDate(checkInDate);
    setEndDate(checkOutDate);
    setBookingData({ ...data, travelDate: startDate });

    fetchPromotions({
      checkInDateFromBooking: checkInDate,
      packageIdFromBooking: Number(data?.packageId),
    });
  }, [location.search]);

  const totalAddonsCostWithoutCommission = selectedAddOns?.reduce(
    (total, addon) => {
      if (addon.priceWithMarkup) {
        if (addon.perPerson && guest) {
          return total + Number(addon.priceWithMarkup) * Number(guest);
        } else {
          return total + Number(addon.priceWithMarkup);
        }
      }
    },
    0
  );

  const totalAddonsCost = selectedAddOns?.reduce((total, addon) => {
    if (addon.perPerson && guest) {
      return total + Number(addon.finalAddonPrice) * Number(guest);
    } else {
      return total + Number(addon.finalAddonPrice);
    }
  }, 0);

  const [priceLoader, setPriceLoader] = useState(false);

  const getRatesFromApi = async (
    packageHub,
    packageDestination,
    todatDays,
    totalNights,
    selectedVehicle
  ) => {
    setPriceLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);
    const destinationNames = packageDestination?.map((dest) => dest.name);

    const formdata = new FormData();
    formdata.append("hub", packageHub);
    destinationNames?.forEach((name) => {
      formdata.append("destinations[]", name);
    });
    formdata.append("days", todatDays);
    formdata.append("nights", totalNights);
    formdata.append("vehicle_type", selectedVehicle);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    const MIN_LOADING_TIME = 800;
    try {
      const startTime = Date.now();
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/transport-fixed-rates/fetch`,
        requestOptions
      );
      const result = await response.json();
      setRatesOfPackages(result?.data[0]);
      const timeElapsed = Date.now() - startTime;
      const remainingTime = MIN_LOADING_TIME - timeElapsed;

      if (remainingTime > 0) {
        setTimeout(() => setPriceLoader(false), remainingTime);
      } else {
        setPriceLoader(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    if (
      singleTransportData?.packageHub &&
      singleTransportData?.packageDestination &&
      singleTransportData?.totalDays &&
      singleTransportData?.totalNights &&
      selectedVehicle
    ) {
      getRatesFromApi(
        singleTransportData?.packageHub,
        singleTransportData?.packageDestination,
        singleTransportData?.totalDays,
        singleTransportData?.totalNights,
        selectedVehicle
      );
    }
  }, [singleTransportData, selectedVehicle]);

  // reusable fn
  function calculateFinalPrice(basePrice, markupData, commissionData) {
    let finalPrice = 0;
    let priceAfterMarkup = 0;

    if (!basePrice || typeof basePrice !== "number" || basePrice <= 0) {
      return;
    }

    finalPrice = basePrice;

    if (markupData?.markupType && markupData?.amount) {
      if (markupData.markupType === "percentage") {
        finalPrice += (basePrice * markupData.amount) / 100;
      } else if (markupData.markupType === "fixed") {
        finalPrice += Number(markupData.amount);
      }
    }
    priceAfterMarkup = finalPrice;

    return { finalPrice, priceAfterMarkup };
  }

  function calculateTotalAmount(
    basePrice = 0,
    selectedAutomaticDiscount,
    selectedDiscount,
    // discount = 0,
    // discountType = "fixed",
    guest = 2,
    ratesOfPackages,
    childAgeArray,
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    volvoAddonPrice,
    markupData,
    commissionAmount,
    commissionType
  ) {
    const childWithAgeGreaterThanSix = childAgeArray.filter(
      (age) => age > 6
    )?.length;
    const childWithAgeLessThanSix = childAgeArray.filter(
      (age) => age <= 6
    )?.length;

    const perPaxCount =
      Number(bookingData.guest) +
      childAgeArray?.length +
      ratesOfPackages?.ExtraAdultCount;

    guest = Number(guest);

    // discount = Number(discount);

    let startingPrice = basePrice;

    let markupAmount;
    let commissionAmt;

    if (markupData?.markupType) {
      if (markupData?.markupType === "percentage") {
        markupAmount = (basePrice * markupData?.amount) / 100;
      } else {
        markupAmount = Number(markupData?.amount);
      }
    }
    let onlyAdultCost = 0;
    if (markupAmount && basePrice) {
      basePrice = Number(basePrice) + markupAmount;
      // onlyAdultCost = Number(basePrice) + markupAmount;
    }

    // onlyAdultCost = basePrice * guest;
    // basePrice = basePrice * guest;

    let adjustedPackagePrice = startingPrice;

    let adultCosts = 0;
    let extraAdultSavings = 0;

    if (ratesOfPackages?.ExtraAdultCount) {
      adultCosts =
        Number(ratesOfPackages?.ExtraAdultCount) *
        Number(ratesOfPackages?.ExtraAdult);

      // const preExtraAdultPrice = adultCosts;
      let extraAdultMarkuoAmount;
      let extraAdultCommissionAmount;

      if (markupData?.markupType) {
        if (markupData?.markupType === "percentage") {
          extraAdultMarkuoAmount = (adultCosts * markupData?.amount) / 100;
        } else {
          extraAdultMarkuoAmount = Number(markupData?.amount);
        }
      }

      if (adultCosts && extraAdultMarkuoAmount) {
        adultCosts += extraAdultMarkuoAmount;
      }

      const preExtraAdultPostMarkup = adultCosts;

      // if (commissionAmount && commissionType) {
      //   if (commissionType === "percentage") {
      //     extraAdultCommissionAmount =
      //       (Number(adultCosts) * Number(commissionAmount)) / 100;
      //   } else if (commissionType === "fixed") {
      //     extraAdultCommissionAmount = Number(commissionAmount);
      //   }
      // }

      // if (adultCosts && extraAdultCommissionAmount) {
      //   adultCosts -= extraAdultCommissionAmount
      // }

      basePrice = basePrice + adultCosts;
      const postExtraAdultPrice = adultCosts;

      extraAdultSavings = preExtraAdultPostMarkup - postExtraAdultPrice;
    }

    let childCosts = 0;
    let childCostWithBed = 0;
    let childCostWithOutBed = 0;
    let childSavingsWithBed = 0;
    let childSavingsWithoutBed = 0;

    if (childAgeArray?.length > 0) {
      childAgeArray.forEach((age) => {
        if (Number(age) >= 6) {
          // childCostWithBed += Number(calculateFinalPrice(ratesOfPackages?.ChildWithBedCost, markupData, commission));
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithBedCost,
            markupData,
            commission
          );

          childCostWithBed += Number(result?.finalPrice);
          // childSavingsWithBed += Number(result?.priceAfterMarkup - result?.finalPrice);
        } else {
          const result = calculateFinalPrice(
            ratesOfPackages?.ChildWithOutBedCost,
            markupData,
            commission
          );

          if (volvoAddonPrice !== undefined) {
            const volvoCost =
              +volvoAddonPrice / Number(childWithAgeLessThanSix);
            childCostWithOutBed +=
              Number(result?.finalPrice) + result?.volvoCost;
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          } else {
            childCostWithOutBed += Number(result?.finalPrice);
            // childSavingsWithoutBed += Number(result?.priceAfterMarkup - result?.finalPrice);
          }
        }
      });
    }

    // if (commissionAmount && commissionType && totalAddonsCostWithoutCommission && totalAddonsCost) {
    //   totalAgentSavings += (totalAddonsCostWithoutCommission - totalAddonsCost)
    // }

    let totalChildCostPrice = childCostWithBed + childCostWithOutBed;

    if (totalChildCostPrice) {
      basePrice += totalChildCostPrice;
    }

    let discountAmount;

    const calculateAutomaticDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedAutomaticDiscount &&
        selectedAutomaticDiscount?.length > 0 &&
        selectedAutomaticDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const calculateDiscountedAmount = (roomRateParsed) => {
      let finalRoomRate = roomRateParsed;
      let totalDiscount = 0;

      selectedDiscount &&
        selectedDiscount?.length > 0 &&
        selectedDiscount?.forEach((discount) => {
          const { promotionMode, promotionAmount } = discount;

          if (promotionMode === "percentage") {
            const percentageDiscount =
              (finalRoomRate * parseFloat(promotionAmount)) / 100;
            totalDiscount += percentageDiscount;
            finalRoomRate -= percentageDiscount;
          } else {
            const fixedDiscount = parseFloat(promotionAmount);
            if (!isNaN(fixedDiscount)) {
              totalDiscount += fixedDiscount;
              finalRoomRate -= fixedDiscount;
            }
          }
        });

      return totalDiscount;
    };

    const totalBookingAutomaticDiscountAmount =
      calculateAutomaticDiscountedAmount(basePrice);
    const totalBookingDiscountAmount = calculateDiscountedAmount(
      Number(basePrice) -
        Number(
          totalBookingAutomaticDiscountAmount
            ? totalBookingAutomaticDiscountAmount
            : 0
        )
    );

    discountAmount =
      Number(totalBookingAutomaticDiscountAmount) +
      Number(totalBookingDiscountAmount);
    // if (discountType === "percentage") {
    //   discountAmount = (basePrice * discount) / 100;
    // } else {
    //   discountAmount = discount;
    // }

    const priceAfterDiscount = basePrice - discountAmount;

    let calculatedCommissionAmount;

    if (commissionAmount && commissionType) {
      if (commission.commissionType === "percentage") {
        calculatedCommissionAmount =
          (priceAfterDiscount * commission.commissionAmount) / 100;
      } else if (commission.commissionType === "fixed") {
        calculatedCommissionAmount = commission.commissionAmount;
      }
    }

    let subtotal;
    if (calculatedCommissionAmount) {
      subtotal = priceAfterDiscount - calculatedCommissionAmount;
    } else {
      subtotal = priceAfterDiscount;
    }

    if (totalAddonsCost) {
      subtotal += totalAddonsCost;
    }

    const gst = subtotal * 0.05;

    const totalAmount = subtotal + gst;

    const discountPercentage = (discountAmount / basePrice) * 100;

    return {
      basePrice: basePrice.toFixed(2),
      discount: discountAmount.toFixed(2),
      priceAfterDiscount: priceAfterDiscount.toFixed(2),
      gst: gst.toFixed(2),
      totalAmount: totalAmount.toFixed(2),
      discountAmount: discountAmount.toFixed(2),
      discountPercentage: discountPercentage,
      // discountType,
      taxAmount: gst.toFixed(2),
      ExtraAdultCost: adultCosts,
      childCosts,
      childCostWithBed,
      childCostWithOutBed,
      totalChildCostPrice,
      adultNumber: guest,
      onlyAdultCost: onlyAdultCost,
      extraAdultNumber: ratesOfPackages?.ExtraAdultCount,
      extraAdultCost: adultCosts,
      childNumber: childAgeArray?.length,

      perPaxCount,
      perPaxCost: (totalAmount / perPaxCount).toFixed(2),
      calculatedAgentAmount: commissionAmt * guest,
      calculatedCommissionAmount,

      extraAdultSavings,
      childSavingsWithBed,
      childSavingsWithoutBed,
      subtotal,
    };
  }

  const handleDiscountChange = (item) => {
    setSelectedDiscount([item]);
  };

  const selectedPrice =
    ACtype === "withAC"
      ? ratesOfPackages?.PriceWithAC
      : ratesOfPackages?.PriceWithoutAC;

  const calculationsOfPackages = calculateTotalAmount(
    selectedPrice,
    selectedAutomaticDiscount,
    selectedDiscount,
    ratesOfPackages?.NoPax,
    ratesOfPackages,
    bookingData?.childAge ? bookingData?.childAge : [],
    totalAddonsCost,
    totalAddonsCostWithoutCommission,
    "",
    markupData,
    commissionAmount,
    commissionType
  );
  useEffect(() => {
    if (!ratesOfPackages) return;

    setPriceLoader(true);
    const delay = setTimeout(() => {
      setPriceLoader(false);
    }, 800); // 800ms minimum loader time

    return () => clearTimeout(delay);
  }, [ACtype]);

  const navigateToCheckOutTransport = () => {
    navigate(`/checkout-transport-search`, {
      state: {
        transportData: singleTransportData,
        bookingData: bookingData,
        selectedVehicle: selectedVehicle,
        selectedCategory: selectedCategory,
        calculationsOfPackages: calculationsOfPackages,
        selectedAddOns: selectedAddOns,
        customized: false,
        ratesOfPackages,
        markupData,
        selectedMealPlan: selectedMealPlan,
        allPackageHotels: allPackageHotels,
        commission: commission,
        // roomsDetails: roomsDetails,
        totalAddonsCost: totalAddonsCost,
        totalAddonsCostWithoutCommission: totalAddonsCostWithoutCommission,
        selectedAutomaticDiscount: selectedAutomaticDiscount,
        selectedDiscount: selectedDiscount,
        selectedVehicle: selectedVehicle,
      },
    });
  };

  const under6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) < 6
  );
  const over6AgeChildren = bookingData?.childAge?.filter(
    (age) => Number(age) >= 6
  );

  // const checkDates = (startDate, endDate) => {
  //   const currentDate = new Date();
  //   const start = new Date(startDate);
  //   const end = new Date(endDate);

  //   return currentDate >= start && currentDate <= end;
  // };

  // const checkBookingDates = (
  //   checkinBookingDate,
  //   checkoutBookingDate,
  //   discountStartDate,
  //   discountEndDate
  // ) => {
  //   const checkin = new Date(checkinBookingDate);
  //   const checkout = new Date(checkoutBookingDate);
  //   const discountStart = new Date(discountStartDate);
  //   const discountEnd = new Date(discountEndDate);

  //   return checkin <= discountEnd && checkout >= discountStart;
  // };

  const [isExpanded, setIsExpanded] = useState(true);
  const [isExpandedAddon, setIsExpandedAddon] = useState(false);

  const toggleAccordionAddon = () => {
    setIsExpandedAddon(!isExpandedAddon);
  };

  const checkDates = (startDate, endDate) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    const start = startDate.split("T")[0];
    const end = endDate.split("T")[0];
    return (
      getCurrentDateFormatted() >= start && getCurrentDateFormatted() <= end
    );
  };

  const checkBookingDates = (
    checkinBookingDate,
    checkoutBookingDate,
    discountStartDate,
    discountEndDate
  ) => {
    const getCurrentDateFormatted = () => {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, "0");
      const day = String(currentDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const checkin = checkinBookingDate?.split("T")[0];
    const checkout = checkoutBookingDate?.split("T")[0];
    const discountStart = discountStartDate?.split("T")[0];
    const discountEnd = discountEndDate?.split("T")[0];

    return checkin <= discountEnd && checkout >= discountStart;

    // return (
    //   getCurrentDateFormatted() >= discountStart &&
    //   getCurrentDateFormatted() <= discountEnd &&
    //   checkout >= discountStart &&
    //   checkin <= discountEnd
    // );
  };

  const isPromotionApplicable = (userType, userId, promotionApplicable) => {
    if (
      Array.isArray(promotionApplicable) &&
      promotionApplicable.length === 0
    ) {
      return true;
    }

    if (promotionApplicable) {
      return promotionApplicable?.some((applicable) => {
        return (
          applicable?.applicableTo === userType &&
          applicable?.applicableIds?.includes(userId?.toString())
        );
      });
    }
  };

  const isBlackoutDate = (blackoutDates, checkDate) => {
    const normalizedCheckDate = new Date(checkDate).toLocaleDateString("en-CA");
    return blackoutDates.some((blackout) => {
      const blackoutDate = new Date(blackout.date).toISOString().split("T")[0];
      return blackoutDate === normalizedCheckDate;
    });
  };

  // const isPromotionApplicableForEntity = (
  //   promotionEntities,
  //   currentEntityType,
  //   currentEntityId
  // ) => {
  //   return promotionEntities.some((entity) => {
  //     return (
  //       entity.entityType === currentEntityType &&
  //       entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
  //     );
  //   });
  // };

  const isPromotionApplicableForEntity = (
    promotionEntities,
    currentEntityType,
    currentEntityId
  ) => {
    return promotionEntities.some((entity) => {
      return (
        entity.entityType === currentEntityType &&
        entity?.entityIds?.some((id) => Number(id) === Number(currentEntityId))
      );
    });
  };

  const evaluateConditions = (conditions, validity) => {
    if (conditions.length === 0) {
      return true;
    }
    const evaluateCondition = (condition, dateToCheck) => {
      const { conditionType, conditionCondition, conditionValue } = condition;
      let startDate = new Date();
      let endDate = new Date();
      endDate.setDate(startDate.getDate() + 1);
      let inputDate = new Date(dateToCheck);
      let currentDate = new Date(currentDateSingle);
      let comparisonValue;
      let valueToCompare;

      const los = calculateLOS(startDate, endDate);

      if (conditionType === "booking_date") {
        comparisonValue = moment(currentDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(currentDate);
        valueToCompare = new Date(conditionValue);
      } else if (conditionType === "LOS") {
        comparisonValue = los;
        valueToCompare = conditionValue;
      } else {
        comparisonValue = moment(inputDate).format("DD-MM-YYYY");
        valueToCompare = moment(conditionValue).format("DD-MM-YYYY");

        comparisonValue = new Date(inputDate);
        valueToCompare = new Date(conditionValue);
      }

      switch (conditionCondition) {
        case "=":
          return comparisonValue.getTime() === valueToCompare.getTime();
        case ">":
          return comparisonValue > valueToCompare;
        case "!=":
          return comparisonValue != valueToCompare;
        case ">=":
          return comparisonValue >= valueToCompare;
        case "<":
          return comparisonValue < valueToCompare;
        case "<=":
          return comparisonValue <= valueToCompare;
        default:
          return false;
      }
    };

    // let result = conditions.length > 0 ? true : false;

    // for (const condition of conditions) {
    //   const conditionResult = evaluateCondition(condition, validity);

    //   if (condition.logicalCondition === "OR" || !conditions.length === 1) {
    //     result = result || conditionResult;
    //   } else {
    //     result = result && conditionResult;
    //   }
    // }
    // return result;

    if (conditions.length === 1) {
      return evaluateCondition(conditions[0], validity);
    }

    const logicalCondition = conditions[0].logicalCondition || "AND";

    let result = logicalCondition === "AND" ? true : false;

    for (const condition of conditions) {
      const conditionResult = evaluateCondition(condition, validity);

      if (logicalCondition === "OR") {
        result = result || conditionResult;
      } else {
        result = result && conditionResult;
      }
    }

    return result;
  };

  const fetchPromotions = async ({
    checkInDateFromBooking,
    packageIdFromBooking,
  }) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Accept", "application/json");
      myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
      myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/promotions`,
        requestOptions
      );
      const result = await response.json();
      setPromotions(result?.data);

      const applicableAutomaticPromotion = result?.data
        ?.filter((item) => {
          const isAutomatic = item.promotionType === "automatic";

          const isValidDate = checkDates(item.startDate, item.endDate);

          const isBookingWithinDiscount = checkBookingDates(
            checkInDateFromBooking,
            checkInDateFromBooking,
            item.startDate,
            item.endDate
          );

          const isUserEligible = isPromotionApplicable(
            userType === "customer"
              ? "customers"
              : userType === "agent"
              ? "agents"
              : "",
            userDetails?.id,
            item.promotionApplicable
          );

          const blackoutDates = item.promotionBlackOutDate || [];

          const isBlackout = isBlackoutDate(
            blackoutDates,
            checkInDateFromBooking
          );

          const isApplicableForEntity = isPromotionApplicableForEntity(
            item.promotionEntity,
            "transport",
            packageIdFromBooking
          );

          const isConditionsValid = evaluateConditions(
            item.promotionConditions,
            checkInDateFromBooking
          );

          return (
            isAutomatic &&
            isValidDate &&
            isBookingWithinDiscount &&
            isUserEligible &&
            !isBlackout &&
            isApplicableForEntity &&
            isConditionsValid
          );
        })
        ?.sort((a, b) => b.stackable - a.stackable);

      let selectedPromotions = [];

      if (applicableAutomaticPromotion.length > 0) {
        const firstPromotion = applicableAutomaticPromotion[0];
        selectedPromotions.push(firstPromotion);

        if (applicableAutomaticPromotion.length > 1) {
          const secondPromotion = applicableAutomaticPromotion[1];
          if (firstPromotion.stackable && secondPromotion.stackable) {
            selectedPromotions.push(secondPromotion);
          }
        }
      }

      setSelectedAutomaticDiscount(selectedPromotions);
    } catch (error) {
      console.error("Error fetching promotions:", error);
    }
  };

  const fetchCommissions = async () => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("Authorization", `Bearer ${userToken}`);
    myHeaders.append("Cookie", `${process.env.REACT_APP_COOKIE}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: urlencoded,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/website/validate/fetch/commission/package/${packageId}`,
        requestOptions
      );
      const data = await response.json();
      if (data.success) {
        if (
          data?.data?.commissionType != "none" &&
          data?.data?.commissionAmount !== 0
        ) {
          setCommission(data?.data);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (packageId && userType === "agent") {
      fetchCommissions();
    }
  }, [packageId, userType]);
  const mainFilters = [
    { label: "Detailed Itinerary", value: "detailed_itinerary" },
    { label: "Inclusions & Exclusions", value: "inclusion_exclusion" },
    { label: "Points To Remember", value: "points_to_remember" },
    { label: "Cancellation Policy", value: "cancellation_policy" },
  ];
  const [activeFilter, setActiveFilter] = useState("overview");
  const [showAllTabs, setShowAllTabs] = useState(false);

  const handleTabClick = (value) => {
    if (value === "overview") {
      setShowAllTabs(!showAllTabs); // Toggle visibility of other tabs
    }
    setActiveFilter(value);
  };
  // Filter Scroll Section
  const handleScrollToSection = (sectionValue) => {
    setFilter(sectionValue);

    setOpenOuterAccordion([sectionValue]);

    const section = document.getElementById(sectionValue);
    if (section) {
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY;
      const sectionHeight = section.offsetHeight;
      const windowHeight = window.innerHeight;

      const scrollTo = sectionPosition - windowHeight / 3 + sectionHeight / 3;

      window.scrollTo({
        top: scrollTo,
        behavior: "smooth",
      });
    }

    setShowAllTabs(false);
    setOpenOuterAccordion([sectionValue]);
  };
  return (
    <>
      {/* <NewUiHeader /> */}
      {/* <EditNewUiSearchFormTransport
        includingDestinations={includingDestinations}
      /> */}
      <PageMetaData
        title={`${
          singleTransportData?.packageName &&
          singleTransportData?.packageName !== "" &&
          singleTransportData?.packageName !== undefined &&
          singleTransportData?.packageName
        } - Mountain Mysteries`}
        description="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <OgMetaTitles
        title={`${
          singleTransportData?.packageName &&
          singleTransportData?.packageName !== "" &&
          singleTransportData?.packageName !== undefined &&
          singleTransportData?.packageName
        } - Mountain Mysteries`}
        type="Enhance your hotel capabilities with RevCatalyst's powerful system. Optimize performance, streamline operations, and unleash the full potential of property."
        url={`https://www.mountainmysteries.com/package/${singleTransportData?.packagehandle}?location=&guest=2&children=0&packagehandle=${singleTransportData?.packagehandle}#package-information`}
      />
      {/* new ui */}
      <div className="sidebar_main_div new_sidebar_main_div">
        <AgentSideBar />
        <div className="agent-info-container">
          <AgentHeader showSelectProperty={true} vendorProperty={false} />

          <div className={`${styles.section_with_background} mt-20`}>
            <div className={styles.container}>
              {/* Package Main Heading */}
              <div>
                <div className={styles.top_transport}>
                  <div>
                    {/* Package Name */}
                    {loader ? (
                      <Skeleton width={400} height={25} />
                    ) : (
                      <div className={styles.package_name}>
                        <div className="flex flex_gap_10 flex_wrap flex_gap_5 align_items_center">
                          <h4>{singlePackage?.packageName}</h4>

                          <div className={`${styles.days_and_night} flex`}>
                            <span className="flex align_items_center">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_6964_11945"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="14"
                                >
                                  <rect width="14" height="14" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_6964_11945)">
                                  <path
                                    d="M6.99644 3.04004C6.87238 3.04004 6.7685 2.99814 6.68479 2.91434C6.60099 2.83043 6.55908 2.7265 6.55908 2.60254V1.32373C6.55908 1.19977 6.60104 1.09589 6.68494 1.01208C6.76884 0.928182 6.87277 0.88623 6.99673 0.88623C7.12079 0.88623 7.22467 0.928182 7.30838 1.01208C7.39218 1.09589 7.43408 1.19977 7.43408 1.32373V2.60254C7.43408 2.7265 7.39213 2.83043 7.30823 2.91434C7.22433 2.99814 7.1204 3.04004 6.99644 3.04004ZM9.7944 4.20219C9.7136 4.12149 9.67413 4.0215 9.67598 3.90221C9.67783 3.78292 9.71915 3.67801 9.79994 3.5875L10.6895 2.67779C10.7773 2.58728 10.8815 2.54202 11.0022 2.54202C11.1228 2.54202 11.2288 2.58767 11.3201 2.67896C11.4038 2.76267 11.4457 2.8647 11.4457 2.98506C11.4457 3.10552 11.4034 3.20799 11.3188 3.29248L10.4091 4.20219C10.3246 4.28677 10.2221 4.32906 10.1017 4.32906C9.98131 4.32906 9.87888 4.28677 9.7944 4.20219ZM11.394 7.4375C11.2701 7.4375 11.1662 7.39555 11.0822 7.31165C10.9984 7.22774 10.9565 7.12381 10.9565 6.99986C10.9565 6.8758 10.9984 6.77192 11.0822 6.68821C11.1662 6.6044 11.2701 6.5625 11.394 6.5625H12.6729C12.7968 6.5625 12.9007 6.60445 12.9845 6.68836C13.0684 6.77226 13.1104 6.87619 13.1104 7.00015C13.1104 7.1242 13.0684 7.22808 12.9845 7.31179C12.9007 7.3956 12.7968 7.4375 12.6729 7.4375H11.394ZM6.99644 13.1138C6.87238 13.1138 6.7685 13.0718 6.68479 12.9879C6.60099 12.9041 6.55908 12.8002 6.55908 12.6763V11.403C6.55908 11.279 6.60104 11.1752 6.68494 11.0914C6.76884 11.0075 6.87277 10.9655 6.99673 10.9655C7.12079 10.9655 7.22467 11.0075 7.30838 11.0914C7.39218 11.1752 7.43408 11.279 7.43408 11.403V12.6763C7.43408 12.8002 7.39213 12.9041 7.30823 12.9879C7.22433 13.0718 7.1204 13.1138 6.99644 13.1138ZM3.58977 4.20219L2.67437 3.30706C2.58386 3.21966 2.5386 3.11403 2.5386 2.99017C2.5386 2.8664 2.58386 2.76228 2.67437 2.67779C2.75886 2.597 2.86255 2.55661 2.98544 2.55661C3.10833 2.55661 3.20953 2.597 3.28906 2.67779L4.20446 3.59319C4.28525 3.67272 4.32565 3.77393 4.32565 3.89681C4.32565 4.0197 4.28564 4.12149 4.20563 4.20219C4.11832 4.28298 4.01648 4.32338 3.9001 4.32338C3.78363 4.32338 3.68019 4.28298 3.58977 4.20219ZM10.6952 11.3222L9.79994 10.4125C9.71915 10.322 9.67783 10.2171 9.67598 10.0978C9.67413 9.9785 9.71322 9.87851 9.79323 9.79781C9.87324 9.71702 9.97328 9.67663 10.0934 9.67663C10.2133 9.67663 10.3186 9.71887 10.4091 9.80336L11.3188 10.6986C11.4056 10.7793 11.4475 10.8808 11.4445 11.0031C11.4415 11.1254 11.399 11.2318 11.3172 11.3222C11.2278 11.4127 11.1217 11.458 10.9988 11.458C10.8758 11.458 10.7746 11.4127 10.6952 11.3222ZM1.32031 7.4375C1.19635 7.4375 1.09247 7.39555 1.00867 7.31165C0.924764 7.22774 0.882812 7.12381 0.882812 6.99986C0.882812 6.8758 0.924764 6.77192 1.00867 6.68821C1.09247 6.6044 1.19635 6.5625 1.32031 6.5625H2.59913C2.72308 6.5625 2.82701 6.60445 2.91092 6.68836C2.99472 6.77226 3.03663 6.87619 3.03663 7.00015C3.03663 7.1242 2.99472 7.22808 2.91092 7.31179C2.82701 7.3956 2.72308 7.4375 2.59913 7.4375H1.32031ZM2.67992 11.3222C2.59913 11.2377 2.55781 11.1343 2.55596 11.012C2.55411 10.8898 2.59358 10.7883 2.67437 10.7075L3.57854 9.80336C3.66303 9.71887 3.76399 9.67663 3.88144 9.67663C3.99879 9.67663 4.10272 9.71848 4.19323 9.80219C4.28374 9.89348 4.329 9.99877 4.329 10.1181C4.329 10.2374 4.28374 10.3422 4.19323 10.4326L3.30365 11.3222C3.21313 11.4127 3.10643 11.458 2.98354 11.458C2.86065 11.458 2.75944 11.4127 2.67992 11.3222ZM6.9979 10.2083C6.10705 10.2083 5.3494 9.89654 4.72494 9.27296C4.10048 8.64938 3.78825 7.89216 3.78825 7.00131C3.78825 6.11047 4.10004 5.35281 4.72363 4.72836C5.34721 4.1039 6.10442 3.79167 6.99527 3.79167C7.88612 3.79167 8.64377 4.10346 9.26823 4.72704C9.89269 5.35063 10.2049 6.10784 10.2049 6.99869C10.2049 7.88954 9.89313 8.64719 9.26954 9.27165C8.64596 9.89611 7.88874 10.2083 6.9979 10.2083Z"
                                    fill="#666666"
                                  />
                                </g>
                              </svg>
                              {singlePackage?.totalDays}D /{" "}
                            </span>
                            <span className="flex align_items_center">
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <mask
                                  id="mask0_6964_11940"
                                  style={{ maskType: "alpha" }}
                                  maskUnits="userSpaceOnUse"
                                  x="0"
                                  y="0"
                                  width="14"
                                  height="14"
                                >
                                  <rect width="14" height="14" fill="#D9D9D9" />
                                </mask>
                                <g mask="url(#mask0_6964_11940)">
                                  <path
                                    d="M7.06094 12.5417C6.2854 12.5417 5.55813 12.3945 4.87913 12.1002C4.20003 11.806 3.6077 11.406 3.10215 10.9005C2.59659 10.3949 2.19667 9.80259 1.90238 9.12349C1.60808 8.44449 1.46094 7.71722 1.46094 6.94168C1.46094 5.82061 1.76422 4.79662 2.37079 3.8697C2.97726 2.94269 3.79763 2.26568 4.83188 1.83868C5.01592 1.7609 5.18999 1.77456 5.3541 1.87966C5.51822 1.98466 5.60105 2.13404 5.6026 2.32781C5.61456 3.13922 5.77294 3.91267 6.07773 4.64816C6.38242 5.38374 6.82085 6.03756 7.393 6.60962C7.96506 7.18177 8.61698 7.61927 9.34877 7.92212C10.0806 8.22506 10.8522 8.38251 11.6636 8.39447C11.879 8.39593 12.0372 8.47818 12.1381 8.64122C12.2391 8.80426 12.2508 8.98077 12.173 9.17074C11.7339 10.1991 11.0524 11.018 10.1284 11.6275C9.20449 12.2369 8.18201 12.5417 7.06094 12.5417Z"
                                    fill="#666666"
                                  />
                                </g>
                              </svg>
                              {singlePackage?.totalNights}N
                            </span>
                          </div>

                          <div
                            className={`${styles.starting_location} font_12 flex align_items_center`}
                          >
                            <span className="flex align_items_center">
                              <SvgLocation />
                            </span>
                            {singlePackage?.packageHub}
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="flex justify_content_between align_items_center">
                      {/* Package Destinations */}
                      <div className={styles.all_destinations_wrapper}>
                        {allDestinations &&
                          allDestinations.length > 0 &&
                          allDestinations.map((item, index) => (
                            <div
                              key={index}
                              className={styles.all_destinations_card}
                            >
                              {item.night}N {item.destination}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                  {/* Download / Share / Mail / Print */}
                  {loader ? (
                    <div className={styles.options_btns_wrapper}>
                      <div className={styles.options_btns_card}>
                        <Skeleton width={40} height={20} />
                      </div>
                      <div className={styles.options_btns_card}>
                        <Skeleton width={40} height={20} />
                      </div>
                      {/* <div className={styles.options_btns_card}>
                    <Skeleton width={40} height={20} />
                  </div> */}
                      <div className={styles.options_btns_card}>
                        <Skeleton width={40} height={20} />
                      </div>
                    </div>
                  ) : (
                    <div className={styles.options_btns_wrapper}>
                      <div className={styles.options_btns_card}>
                        <span className="flex align_items_center">
                          <PackageDetails
                            packageData={singlePackage}
                            setOpenGetQuotePopup={setOpenGetQuotePopup}
                            selectedCategory={selectedCategory}
                            allPackageHotels={allPackageHotels}
                          />
                        </span>
                      </div>
                      <div className={styles.vertical_line}></div>
                      <div className={styles.options_btns_card}>
                        <span className="flex align_items_center">
                          <NewShare singlePackageData={singlePackage} />
                        </span>
                      </div>
                      <div className={styles.vertical_line}></div>
                      <div className={styles.options_btns_card}>
                        <span className="flex align_items_center">
                          <NewPrint packageData={singlePackage} />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {/*  */}
            <section
              className={`${styles.section_with_background} ${styles.main_details_section}`}
              style={{ paddingTop: "0" }}
            >
              {/* Filter Section */}
              <div className={`${styles.filter_section}`}>
                <div className={styles.container_inside}>
                  <div className={styles.filter_wrapper}>
                    {mainFilters.map((item, index) => (
                      <div
                        key={index}
                        onClick={() => handleScrollToSection(item.value)}
                        className={`${styles.filter_card} ${
                          filter === item.value ? styles.active_filter : ""
                        }`}
                      >
                        {item.label}
                      </div>
                    ))}{" "}
                  </div>
                </div>
              </div>

              <div className={styles.container_withoutBg}>
                <div className={styles.main_details}>
                  <div className={styles.left_wrapper}>
                    {/* Details Itinerary */}
                    {singlePackage?.packageItinerary?.length > 0 && (
                      <div
                        className={styles.left_wrapper_inner}
                        id="detailed_itinerary"
                      >
                        {/* <h6>Detailed Itinerary</h6> */}
                        <div
                          className={styles.parent_div}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("detailed_itinerary")) {
                                return prev.filter(
                                  (item) => item !== "detailed_itinerary"
                                );
                              } else {
                                return [...prev, "detailed_itinerary"];
                              }
                            })
                          }
                        >
                          <h6>Detailed Itinerary</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("detailed_itinerary")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {openOuterAccordion.includes("detailed_itinerary") && (
                          <div
                            className={
                              styles.detailed_itinerary_overview_content
                            }
                          >
                            {singlePackage?.packageItinerary?.length > 0 &&
                              singlePackage?.packageItinerary.map(
                                (item, index) => (
                                  <div
                                    className={
                                      styles.detailed_itinerary_overview_content_card
                                    }
                                  >
                                    <div
                                      style={{
                                        border:
                                          openIndex === index
                                            ? "0.5px solid #009A50"
                                            : "0.5px solid #ccc",
                                      }}
                                      onClick={() => toggleAccordion(index)}
                                      className={`${styles.detailed_itinerary_overview_content_card_top} pointer`}
                                    >
                                      <div
                                        className={
                                          styles.detailed_itinerary_overview_content_card_heading
                                        }
                                      >
                                        <span>Day {index + 1}</span>

                                        <div
                                          className={
                                            styles.detailed_itinerary_overview_content_card_heading_inner_parent
                                          }
                                        >
                                          <div
                                            className={
                                              styles.detailed_itinerary_overview_content_card_heading_right_upper
                                            }
                                          >
                                            {item?.startDestination} to{" "}
                                            {item?.endDestination}
                                          </div>
                                          <div
                                            className={
                                              styles.details_itinerary_start_end_destination
                                            }
                                          >
                                            Starts At: {item?.startDestination}{" "}
                                            | Ends At: {item?.endDestination}
                                          </div>
                                        </div>
                                      </div>
                                      <span
                                        className={`${styles.accordion_icon} ${
                                          openIndex === index
                                            ? styles.active
                                            : ""
                                        }`}
                                      >
                                        <SvgAccordion />
                                      </span>
                                    </div>

                                    <div
                                      className={`
                                  ${
                                    styles.detailed_itinerary_overview_content_card_bottom
                                  } ${openIndex === index ? styles.open : ""}
                                `}
                                    >
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.additionalDetails
                                              ?.short_description,
                                        }}
                                      ></p>
                                      <p
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            item?.additionalDetails
                                              ?.long_description,
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        )}
                        {/* {detailedFilter === "gallery" && (
                    <TransportGallery
                      singleTransportData={singleTransportData}
                      loader={loader}
                    />
                  )} */}
                      </div>
                    )}

                    {/* Inclusions / Exclusions */}
                    {singlePackage?.packagePolicies?.length > 0 && (
                      <div
                        id="inclusion_exclusion"
                        className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("inclusion_exclusion")) {
                                return prev.filter(
                                  (item) => item !== "inclusion_exclusion"
                                );
                              } else {
                                return [...prev, "inclusion_exclusion"];
                              }
                            })
                          }
                        >
                          <h6>Inclusions / Exclusions</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("inclusion_exclusion")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>
                        {openOuterAccordion.includes("inclusion_exclusion") && (
                          <div className={styles.inclusion_exclusion_content}>
                            <div className={styles.inclusion_content}>
                              {singlePackage?.packagePolicies?.length > 0 &&
                                singlePackage?.packagePolicies
                                  .filter((item) => item.type === "inclusion")
                                  .map((item, index) => (
                                    <>
                                      <div
                                        className={
                                          styles.inclusion_content_heading
                                        }
                                      >
                                        Inclusions
                                      </div>

                                      <div
                                        key={index}
                                        className={`${styles.inner_common_content} ${styles.inclusion_inner_content}`}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    </>
                                  ))}
                            </div>
                            <div className={styles.exclusion_content}>
                              {singlePackage?.packagePolicies?.length > 0 &&
                                singlePackage?.packagePolicies
                                  .filter((item) => item.type === "exclusion")
                                  .map((item, index) => (
                                    <>
                                      <div
                                        className={
                                          styles.exclusion_content_heading
                                        }
                                      >
                                        Exclusive
                                      </div>
                                      <div
                                        key={index}
                                        className={`${styles.inner_common_content} ${styles.exclusive_inner_content}`}
                                        dangerouslySetInnerHTML={{
                                          __html: item?.content,
                                        }}
                                      ></div>
                                    </>
                                  ))}
                            </div>
                          </div>
                        )}
                      </div>
                    )}

                    {/* Points To Remember */}
                    {singlePackage?.packagePolicies?.filter(
                      (item) => item.type === "points_to_remember"
                    )?.length > 0 && (
                      <div
                        id="points_to_remember"
                        // className={styles.left_wrapper_inner}
                        className={`${styles.left_wrapper_inner} ${styles.inclusion_exclusion} ${styles.detailed_itinerary}`}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("points_to_remember")) {
                                return prev.filter(
                                  (item) => item !== "points_to_remember"
                                );
                              } else {
                                return [...prev, "points_to_remember"];
                              }
                            })
                          }
                        >
                          <h6>Things to Know</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("points_to_remember")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>
                        {openOuterAccordion.includes("points_to_remember") && (
                          <div className={styles.inner_common_content_style}>
                            {singlePackage?.packagePolicies?.length > 0 &&
                              singlePackage.packagePolicies
                                .filter(
                                  (item) => item.type === "points_to_remember"
                                )
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={styles.inner_common_content}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                          </div>
                        )}
                      </div>
                    )}

                    {/* Cancellation Policy */}
                    {singlePackage?.packagePolicies?.filter(
                      (item) => item.type === "cancellation_policy"
                    )?.length > 0 && (
                      <div
                        id="cancellation_policy"
                        className={styles.left_wrapper_inner}
                      >
                        <div
                          className={styles.parent_div}
                          onClick={() =>
                            setOpenOuterAccordion((prev) => {
                              if (prev.includes("cancellation_policy")) {
                                return prev.filter(
                                  (item) => item !== "cancellation_policy"
                                );
                              } else {
                                return [...prev, "cancellation_policy"];
                              }
                            })
                          }
                        >
                          <h6>Cancellation Policy</h6>

                          <span
                            className={`${styles.accordion_icon} ${
                              openOuterAccordion.includes("cancellation_policy")
                                ? styles.active
                                : ""
                            }`}
                          >
                            <SvgAccordion />
                          </span>
                        </div>

                        {openOuterAccordion.includes("cancellation_policy") && (
                          <div
                            className={`${styles.inner_common_content_style}`}
                          >
                            {singlePackage?.packagePolicies?.length > 0 &&
                              singlePackage.packagePolicies
                                .filter(
                                  (item) => item.type === "cancellation_policy"
                                )
                                .map((item, index) => (
                                  <div
                                    key={index}
                                    className={styles.inner_common_content}
                                    dangerouslySetInnerHTML={{
                                      __html: item?.content,
                                    }}
                                  ></div>
                                ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                  <div className={styles.right_wrapper}>
                    <div
                      className="common_background"
                      style={{ marginBottom: "0", padding: "0" }}
                    >
                      <div
                        className="bg_white border_box"
                        style={{ borderRadius: "15px", overflow: "hidden" }}
                      >
                        <div className="p_10_15 border_bottom">
                          <label>Select Vehicle</label>
                          <select
                            className="w-full"
                            name="meal_plan"
                            value={selectedVehicle}
                            onChange={handleSelectVehicleChange}
                          >
                            <option value="" disabled>
                              Select an option
                            </option>
                            <option value="sedan">Sedan</option>
                            <option value="ertiga">Ertiga</option>
                            <option value="innova-crysta">Innova Crysta</option>
                            <option value="maharaja-tempo">
                              Maharaja Tempo
                            </option>
                            <option value="tempo-traveller-twelve-seater">
                              Tempo Traveller
                            </option>
                            <option value="urbenia-twelve-seater">
                              Urbenia-twelve-seater
                            </option>
                          </select>
                        </div>
                        {/* <hr /> */}

                        <div
                          className="p_10_15 border_bottom"
                          style={{ paddingBottom: "0px" }}
                        >
                          <label>Air Preferences:</label>
                          <div>
                            <label
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                              }}
                            >
                              <input
                                type="radio"
                                name="meal_plan"
                                value="withoutAC"
                                checked={ACtype === "withoutAC"}
                                onChange={(e) => setACtype(e.target.value)}
                              />
                              <span>
                                Selective Cool (Partial AC)
                                <br />
                                <span style={{ fontSize: "11px" }}>
                                  Cooling tailored to the terrain.
                                </span>
                              </span>
                            </label>
                            <label
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                                marginBottom: "10px",
                              }}
                            >
                              <input
                                type="radio"
                                name="meal_plan"
                                value="withAC"
                                checked={ACtype === "withAC"}
                                onChange={(e) => setACtype(e.target.value)}
                              />
                              <span>
                                Constant Breeze (Full AC)
                                <br />
                                <span style={{ fontSize: "11px" }}>
                                  Stay cool at every mile.
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                        {/* )} */}

                        {/* add ons */}
                        <div className={styles.addons_wrapper}>
                          {/* <Link to={"/checkout-package"}> */}

                          {singleTransportData?.packageAddons &&
                            singleTransportData?.packageAddons.length > 0 && (
                              <div
                                style={{
                                  background: isExpandedAddon
                                    ? "#E8F9F1"
                                    : "#fff",
                                }}
                                onClick={toggleAccordionAddon}
                                className=" pointer"
                              >
                                {singleTransportData.packageAddons.some(
                                  (item) =>
                                    !item.detail.includes("Volvo") &&
                                    item.addonType !== "ticket"
                                ) && (
                                  <div className="flex align_items_center justify_content_between p_10">
                                    <h6 style={{ fontSize: "16px" }}>Addons</h6>{" "}
                                    <svg
                                      width="25px"
                                      height="25px"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                      style={{
                                        cursor: "pointer",
                                        transform: isExpandedAddon
                                          ? "rotate(180deg)"
                                          : "rotate(0deg)",
                                        transition: "transform 0.3s ease",
                                      }}
                                    >
                                      <path
                                        d="M7 10L12 15L17 10"
                                        stroke="#333"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </div>
                                )}
                                <div
                                  style={{
                                    display: isExpandedAddon ? "block" : "none",
                                  }}
                                  className={styles.addons_wrapper_div}
                                >
                                  {singleTransportData.packageAddons
                                    .filter(
                                      (item) =>
                                        !item.detail.includes("Volvo") &&
                                        item.addonType !== "ticket"
                                    )
                                    .map((item, index) => {
                                      let finalAddonPrice = item?.price;
                                      let priceWithMarkup = item?.price;

                                      if (markupData) {
                                        const markup = markupData;
                                        if (
                                          markup.markupType === "percentage"
                                        ) {
                                          finalAddonPrice +=
                                            (item.price *
                                              parseFloat(markup.amount)) /
                                            100;
                                        } else if (
                                          markup.markupType === "fixed"
                                        ) {
                                          finalAddonPrice += parseFloat(
                                            markup.amount
                                          );
                                        }
                                      }
                                      priceWithMarkup = finalAddonPrice;

                                      if (
                                        commission?.commissionAmount &&
                                        commission?.commissionType
                                      ) {
                                        if (
                                          commission?.commissionType ===
                                          "percentage"
                                        ) {
                                          finalAddonPrice -=
                                            (Number(finalAddonPrice) *
                                              Number(
                                                commission?.commissionAmount
                                              )) /
                                            100;
                                        } else if (
                                          commission?.commissionType === "fixed"
                                        ) {
                                          finalAddonPrice = Number(
                                            commission?.commissionAmount
                                          );
                                        }
                                      }

                                      return (
                                        <div
                                          key={index}
                                          className={styles.addons_parent}
                                          style={{
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            background: selectedAddOns.some(
                                              (addon) => addon.id === item.id
                                            )
                                              ? "#E8F9F1"
                                              : "#fff",
                                            border: selectedAddOns.some(
                                              (addon) => addon.id === item.id
                                            )
                                              ? "none"
                                              : "1px solid #ccc",
                                          }}
                                        >
                                          <div
                                            style={{
                                              cursor: "pointer",
                                              width: "100%",
                                            }}
                                          >
                                            <div
                                              style={{
                                                fontSize: "12px",
                                                fontWeight: 500,
                                                color: selectedAddOns.some(
                                                  (addon) =>
                                                    addon.id === item.id
                                                )
                                                  ? "#009A50"
                                                  : "#222222",
                                              }}
                                            >
                                              {item.detail}{" "}
                                              {commission?.commissionAmount &&
                                                commission?.commissionType && (
                                                  <span
                                                    style={{
                                                      fontSize: "12px",
                                                      color: "red",
                                                      textDecoration:
                                                        "line-through",
                                                    }}
                                                  >
                                                    {formatIndianCurrency(
                                                      priceWithMarkup
                                                    )}{" "}
                                                    {item.perPerson
                                                      ? `* ${guest}`
                                                      : ""}
                                                  </span>
                                                )}
                                              <div
                                                style={{
                                                  fontSize: "12px",
                                                  marginTop: "5px",
                                                  color: selectedAddOns.some(
                                                    (addon) =>
                                                      addon.id === item.id
                                                  )
                                                    ? "#009A50"
                                                    : "#222222",
                                                }}
                                              >
                                                {formatIndianCurrency(
                                                  finalAddonPrice
                                                )}{" "}
                                                {item.perPerson
                                                  ? `* ${guest}`
                                                  : ""}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            className="flex justify_content_end"
                                            style={{ width: "60%" }}
                                          >
                                            <button
                                              style={{ fontSize: "10px" }}
                                              onClick={() =>
                                                handleSelectedAddOns({
                                                  ...item,
                                                  finalAddonPrice,
                                                  priceWithMarkup,
                                                })
                                              }
                                            >
                                              {selectedAddOns.some(
                                                (addon) => addon.id === item.id
                                              ) ? (
                                                <div>
                                                  <CrossWithBorder />
                                                </div>
                                              ) : (
                                                <div
                                                  style={{
                                                    background: "#009A50",
                                                    color: "#fff",
                                                    padding: "6px 8px",
                                                    display: "flex",
                                                    fontSize: "12px",
                                                  }}
                                                >
                                                  {" "}
                                                  Add
                                                  {/* <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          height="16px"
                                          viewBox="0 -960 960 960"
                                          width="16px"
                                          fill="#ffffff"
                                        >
                                          <path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z" />
                                        </svg> */}
                                                </div>
                                              )}
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            )}
                        </div>

                        <div
                          onClick={() => {
                            togglePaymentDetails();
                            handleButtonClick();
                          }}
                          style={{
                            fontSize: "14px",
                            padding: "10px 15px",
                            background: paymentDetails ? "#E8F9F1" : "#fff",
                          }}
                          className="flex justify_content_between align_items_center border_bottom border_top pointer"
                        >
                          <h6 style={{ fontSize: "16px" }}>Price Breakup</h6>

                          <div>
                            <button
                              className={`${
                                activePayment === "priceSummary" ? "" : ""
                              }`}
                            >
                              <small className="link_btn">
                                {/* {activePayment === "priceSummary"
                          ? "Minimize Breakup"
                          : "View Breakup"}{" "} */}
                              </small>
                              <svg
                                width="13"
                                height="8"
                                viewBox="0 0 13 8"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{
                                  transition: "transform 0.3s",
                                  transform: paymentDetails
                                    ? "rotate(180deg)"
                                    : "rotate(0deg)",
                                }}
                              >
                                <path
                                  d="M11.5527 1.34473L5.86308 6.65507L0.552735 1.34473"
                                  stroke="#222222"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                        <div
                          className="p_10_15"
                          style={{
                            background: paymentDetails ? "#E8F9F1" : "#fff",
                          }}
                        >
                          <>
                            <div className="flex justify_content_between mt-10">
                              <p>
                                <b>Total Cost</b>
                              </p>
                              <span
                                className={` ${
                                  Number(calculationsOfPackages?.totalAmount) <=
                                    0 && "filterBlur3"
                                }`}
                              >
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <b>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.basePrice
                                    )}
                                  </b>
                                )}
                              </span>
                            </div>

                            {activePayment === "priceSummary" && (
                              <>
                                {(selectedAutomaticDiscount.length > 0 ||
                                  selectedDiscount.length > 0) && (
                                  <div className="mt-10">
                                    <p>
                                      <b>
                                        Transport Discount
                                        {selectedAutomaticDiscount?.length > 1
                                          ? "s"
                                          : ""}
                                      </b>
                                    </p>
                                    {selectedAutomaticDiscount?.map(
                                      (discount, index) => (
                                        <div
                                          className="flex justify_content_between mt-2"
                                          key={discount.id}
                                        >
                                          <span className="discount-name">
                                            {discount.promotionName}
                                          </span>
                                          <span className="room_text-right green">
                                            {discount.promotionMode ===
                                            "percentage"
                                              ? `${+discount.promotionAmount}%`
                                              : `${formatIndianCurrency(
                                                  discount.promotionAmount
                                                )}`}
                                          </span>
                                        </div>
                                      )
                                    )}

                                    {selectedDiscount &&
                                      selectedDiscount?.length > 0 &&
                                      selectedDiscount?.map(
                                        (discount, index) => (
                                          <div
                                            className="flex justify_content_between mt-2"
                                            key={discount.id}
                                          >
                                            <span className="discount-name">
                                              {discount.promotionName}
                                            </span>
                                            <span className="room_text-right green">
                                              {discount.promotionMode ===
                                              "percentage"
                                                ? `${+discount.promotionAmount}%`
                                                : `${formatIndianCurrency(
                                                    discount.promotionAmount
                                                  )}`}
                                            </span>
                                          </div>
                                        )
                                      )}
                                  </div>
                                )}

                                {calculationsOfPackages?.discount > 0 && (
                                  <div className="flex justify_content_between mt-10 border-bottom-one ">
                                    <p>Package Cost (After Disc.)</p>
                                    <span
                                      className={`room_text-right ${
                                        Number(
                                          calculationsOfPackages?.totalAmount
                                        ) <= 0 && "filterBlur3"
                                      }`}
                                    >
                                      {priceLoader ? (
                                        <Skeleton
                                          width={80}
                                          height={10}
                                          borderRadius={4}
                                        />
                                      ) : (
                                        <>
                                          {formatIndianCurrency(
                                            calculationsOfPackages?.priceAfterDiscount
                                          )}
                                        </>
                                      )}
                                    </span>
                                  </div>
                                )}

                                {commission &&
                                  Object.keys(commission).length > 0 && (
                                    <>
                                      <div className="flex justify_content_between mt-10">
                                        <p>
                                          Commission{" "}
                                          <small>
                                            ({" "}
                                            {commission.commissionType ===
                                            "fixed" ? (
                                              <span className="room_text-right">
                                                {formatIndianCurrency(
                                                  commission?.commissionAmount
                                                )}
                                              </span>
                                            ) : (
                                              <span className="room_text-right">
                                                {commission?.commissionAmount}%
                                              </span>
                                            )}
                                            )
                                          </small>
                                        </p>

                                        {formatIndianCurrency(
                                          calculationsOfPackages?.calculatedCommissionAmount
                                        )}
                                      </div>
                                    </>
                                  )}

                                {selectedAddOns &&
                                  selectedAddOns.length > 0 && (
                                    <div className="flex justify_content_between mt-10">
                                      <p>Addons Price</p>
                                      <span
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "end",
                                        }}
                                      >
                                        {commission &&
                                          Object.keys(commission).length >
                                            0 && (
                                            <small
                                              style={{
                                                color: "red",
                                                textDecoration: "line-through",
                                              }}
                                            >
                                              {formatIndianCurrency(
                                                totalAddonsCostWithoutCommission
                                              )}
                                            </small>
                                          )}
                                        <b>
                                          {formatIndianCurrency(
                                            totalAddonsCost
                                          )}
                                        </b>
                                      </span>
                                    </div>
                                  )}

                                <div className="flex justify_content_between mt-10">
                                  <p>Subtotal </p>

                                  <span>
                                    {priceLoader ? (
                                      <Skeleton
                                        width={80}
                                        height={10}
                                        borderRadius={4}
                                      />
                                    ) : (
                                      <>
                                        {formatIndianCurrency(
                                          calculationsOfPackages?.subtotal
                                        )}
                                      </>
                                    )}
                                  </span>
                                </div>
                              </>
                            )}

                            <div className="flex justify_content_between mt-10 border-bottom-one ">
                              <p>GST(5%) </p>
                              <span
                                className={`room_text-right  ${
                                  Number(calculationsOfPackages?.totalAmount) <=
                                    0 && "filterBlur3"
                                }`}
                              >
                                {priceLoader ? (
                                  <Skeleton
                                    width={80}
                                    height={10}
                                    borderRadius={4}
                                  />
                                ) : (
                                  <>
                                    {formatIndianCurrency(
                                      calculationsOfPackages?.taxAmount
                                    )}
                                  </>
                                )}
                              </span>
                            </div>

                            <div className="flex justify_content_between mt-10">
                              <div>
                                <b>Total Amount to be paid</b>
                              </div>
                              <div>
                                <span
                                  className={` ${
                                    Number(
                                      calculationsOfPackages?.totalAmount
                                    ) <= 0 && "filterBlur3"
                                  }`}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "end",
                                  }}
                                >
                                  {priceLoader ? (
                                    <Skeleton
                                      width={80}
                                      height={10}
                                      borderRadius={4}
                                    />
                                  ) : (
                                    <b>
                                      {formatIndianCurrency(
                                        calculationsOfPackages?.totalAmount
                                      )}
                                    </b>
                                  )}
                                </span>
                              </div>
                            </div>

                            <button
                              style={{
                                marginTop: "10px",
                                marginBottom: "10px",
                              }}
                              onClick={navigateToCheckOutTransport}
                              className={styles.book_btn}
                            >
                              Book Now
                            </button>
                          </>
                        </div>
                      </div>

                      {promotions.length > 0 && (
                        <div>
                          {promotions.some(
                            (item) =>
                              item.promotionType === "coupon" &&
                              (() => {
                                const isValidDate = checkDates(
                                  item.startDate,
                                  item.endDate
                                );
                                const isBookingWithinDiscount =
                                  checkBookingDates(
                                    startDate,
                                    startDate,
                                    item.startDate,
                                    item.endDate
                                  );
                                const isUserEligible = isPromotionApplicable(
                                  userType === "customer"
                                    ? "customers"
                                    : userType === "agent"
                                    ? "agents"
                                    : "",
                                  userDetails?.id,
                                  item.promotionApplicable
                                );
                                const blackoutDates =
                                  item.promotionBlackOutDate || [];
                                const isBlackout = isBlackoutDate(
                                  blackoutDates,
                                  startDate
                                );
                                const isApplicableForEntity =
                                  isPromotionApplicableForEntity(
                                    item.promotionEntity,
                                    "transport",
                                    singleTransportData?.packageId
                                  );
                                const isConditionsValid = evaluateConditions(
                                  item.promotionConditions,
                                  startDate
                                );

                                return (
                                  isValidDate &&
                                  isBookingWithinDiscount &&
                                  isUserEligible &&
                                  !isBlackout &&
                                  isApplicableForEntity &&
                                  isConditionsValid
                                );
                              })()
                          ) && (
                            <div className={styles.promotion_wrapper}>
                              <div
                                className={styles.promotion_parent}
                                style={{ marginTop: "10px" }}
                              >
                                <div className="flex justify_content_between cursor_pointer ">
                                  <div className="flex justify_content_between w-100">
                                    <div>
                                      <h5
                                        style={{ color: "#009a50" }}
                                        className="text-left"
                                      >
                                        Offers
                                      </h5>
                                    </div>
                                    {selectedDiscount && (
                                      <button
                                        className="view_btn"
                                        onClick={() => setSelectedDiscount([])}
                                      >
                                        clear
                                      </button>
                                    )}
                                  </div>
                                </div>
                                <div>
                                  {promotions?.map((item, index) => {
                                    const isCouponCode =
                                      item?.promotionType === "coupon"
                                        ? true
                                        : false;
                                    const isValidDate = checkDates(
                                      item.startDate,
                                      item.endDate
                                    );
                                    const isBookingWithinDiscount =
                                      checkBookingDates(
                                        startDate,
                                        startDate,
                                        item.startDate,
                                        item.endDate
                                      );
                                    const isUserEligible =
                                      isPromotionApplicable(
                                        userType === "customer"
                                          ? "customers"
                                          : userType === "agent"
                                          ? "agents"
                                          : "",
                                        userDetails?.id,
                                        item.promotionApplicable
                                      );
                                    const blackoutDates =
                                      item.promotionBlackOutDate || [];
                                    const isBlackout = isBlackoutDate(
                                      blackoutDates,
                                      startDate
                                    );
                                    const isApplicableForEntity =
                                      isPromotionApplicableForEntity(
                                        item.promotionEntity,
                                        "transport",
                                        singleTransportData?.packageId
                                      );

                                    const isConditionsValid =
                                      evaluateConditions(
                                        item.promotionConditions,
                                        startDate
                                      );

                                    return (
                                      isCouponCode &&
                                      isValidDate &&
                                      isBookingWithinDiscount &&
                                      isUserEligible &&
                                      !isBlackout &&
                                      isApplicableForEntity &&
                                      isConditionsValid && (
                                        <div
                                          key={index}
                                          style={{
                                            backgroundColor:
                                              selectedDiscount?.some(
                                                (discount) =>
                                                  discount.id === item.id
                                              )
                                                ? "#E8F9F1"
                                                : "#fff",
                                          }}
                                          className={styles?.discountSingleDiv}
                                        >
                                          <div className="flex">
                                            <label
                                              style={{
                                                textTransform: "capitalize",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                color: selectedDiscount?.some(
                                                  (discount) =>
                                                    discount.id === item.id
                                                )
                                                  ? "#009a50"
                                                  : "#333",
                                              }}
                                              htmlFor={item?.promotionName}
                                            >
                                              {" "}
                                              <input
                                                checked={selectedDiscount?.some(
                                                  (discount) =>
                                                    discount.id === item.id
                                                )}
                                                onChange={() =>
                                                  handleDiscountChange(item)
                                                }
                                                type="radio"
                                                id={item.promotionName}
                                              />
                                              <div>
                                                <div>
                                                  {item?.promotionName?.replace(
                                                    /-/g,
                                                    " "
                                                  )}
                                                </div>
                                              </div>
                                            </label>
                                          </div>
                                          <div
                                            style={{
                                              color: selectedDiscount?.some(
                                                (discount) =>
                                                  discount.id === item.id
                                              )
                                                ? "#009a50"
                                                : "#333",
                                            }}
                                          >
                                            {item?.promotionMode === "fixed" ? (
                                              formatIndianCurrency(
                                                item?.promotionAmount
                                              )
                                            ) : (
                                              <>{item?.promotionAmount}%</>
                                            )}
                                          </div>
                                        </div>
                                      )
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    {/* <OurQuery /> */}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
      <div className={styles.footer_bottom_align}>
        {" "}
        {/* <NewFooterUI />{" "} */}
      </div>

      <div className={styles.mobile_price_breakup}>
        <div className="">
          <div className="">
            <div>Total Amt.</div>
            <div>
              <span
                className={` ${
                  Number(calculationsOfPackages?.totalAmount) <= 0 &&
                  "filterBlur3"
                }`}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                }}
              >
                <b>
                  {formatIndianCurrency(calculationsOfPackages?.totalAmount)}
                </b>
              </span>
            </div>
          </div>
        </div>
        <button
          className={styles.book_btn}
          onClick={navigateToCheckOutTransport}
        >
          Continue
        </button>
      </div>
      {showRatePopup && (
        <NewSendEnquiryPopup
          package_id={singleTransportData?.packageId}
          setshowRatePopup={setshowRatePopup}
          typeDetail="package"
        />
      )}
    </>
  );
}

export default NewSingleTransportPage;
